// Usage: import { FeatureFlags } from 'app/_shared/services/config/feature.flags';
export const FeatureFlags = {
    UseNewSecurity: 'UseNewSecurity',
    DisableGlobalHeatMapOption: 'DisableGlobalHeatMapOption',
    DisableGlobalSorting: 'DisableGlobalSorting',
};